/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { ListItem, Button, TextField, InputAdornment, Tooltip, MenuItem, Grid } from "@material-ui/core";
import { FormTextField } from "../../../../components";
import { WEB_CHAT_TOOL_TIPS } from "../../../../utility/toolTipMessages";

export const LanguageTermItem = ({
	termValue,
	languageCode,
	id,
	setFormEdited,
	isSourceLang,
	supportedLanguages,
	language,
	formEdited,
	onTermUpdate,
	onRemove,
	isTermExists,
}) => {
	const handleUpdate = (key, value) => {
		onTermUpdate(id, key, value);
	};

	return (
		<ListItem className="px-0">
			<Grid container spacing={2} alignItems="flex-start" justifyContent="space-between" wrap="wrap">
				<Grid item xs={12} lg={5}>
					<FormTextField
						formEdited={formEdited}
						label="Term"
						setEdited={setFormEdited}
						required
						startingValue={termValue}
						setConfigValue={handleUpdate}
						valueName="value"
						styleObject={{ width: "100%", flex: 1 }}
						errorMessage={
							isTermExists && isSourceLang
								? "Translations for this term is already defined."
								: "Translation term is required"
						}
						errorCheck={(val) => !val || (isTermExists && isSourceLang)}
						toolTipMessage="Enter the translation term"
					/>
				</Grid>
				<Grid item xs={9} lg={5}>
					{supportedLanguages && (
						<TextField
							label={"Language"}
							select
							disabled={isSourceLang}
							className="w-100"
							value={languageCode || ""}
							onChange={(event) => {
								const edited = language?.displayName !== event.target.value;
								if (edited) {
									setFormEdited(true);
									handleUpdate("languageCode", event.target.value);
								}
							}}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Tooltip
											arrow
											interactive
											placement={"bottom-start"}
											title={WEB_CHAT_TOOL_TIPS.LANGUAGE_TRANSLATOR_LANGUAGES_LOOKUP}
										>
											<i style={{ height: "15px", color: "gray" }} className="fas fa-info-circle" />
										</Tooltip>
									</InputAdornment>
								),
							}}
						>
							{(supportedLanguages || []).map((lang) => {
								return (
									lang && (
										<MenuItem key={lang.languageCode} value={lang.languageCode}>
											{lang.displayName}
										</MenuItem>
									)
								);
							})}
						</TextField>
					)}
				</Grid>
				<Grid item xs={3} lg={2} className="align-self-center">
					{!isSourceLang && (
						<Button variant="outlined" className="float-right" size="small" onClick={onRemove}>
							Remove
						</Button>
					)}
				</Grid>
			</Grid>
		</ListItem>
	);
};
